import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TextState } from "../objects/textState";
import { ADD_CUSTOM_PICTURES } from "../../../picture/redux/actionTypes";
import { Picture } from "../../../picture/objects/picture";

const initialState: TextState = {
    editor_pictures: []
};

const addEditorPicturesExtraReducer = (state: TextState, action: PayloadAction<Picture[]>): TextState => ({
    ...state, editor_pictures: action.payload
});

const setEditorPicturesReducer = (state: TextState, action: PayloadAction<Picture[]>): TextState => ({
    ...state, editor_pictures: action.payload
});


export const text = createSlice({
    name: 'text',
    initialState,
    reducers: {
        setEditorPictures: setEditorPicturesReducer
    },
    extraReducers: {
        [ADD_CUSTOM_PICTURES]: addEditorPicturesExtraReducer,
    }
});